import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  passwordField: {
    maxWidth: '358px',
    '& div': {
      maxHeight: '44px',
    },
    '& button': {
      padding: '9px 14px',
    },
    '& input': {
      padding: '11px 16px',
    },
    '& p': {
      lineHeight: 1,
      fontSize: '0.87em',
    },
  },
});
